import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,App } from 'ionic-angular';
import {EmiempirelateddetailsPage} from '../emiempirelateddetails/emiempirelateddetails'
import {CancelMandatePage} from '../cancel-mandate/cancel-mandate';

/**
 * Generated class for the EmiempirelatedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-emiempirelated',
  templateUrl: 'emiempirelated.html',
})
export class EmiempirelatedPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,private app:App) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad EmiempirelatedPage',this.navParams);
  }
  goToPage(){
    let nav = this.app.getRootNav();
    nav.push(EmiempirelateddetailsPage,this.navParams)
  }
  goToPageName(){
    let nav = this.app.getRootNav();
    nav.push(CancelMandatePage,this.navParams)
  
  }


}



// WEBPACK FOOTER //
// ./src/pages/emiempirelated/emiempirelated.ts